const { createConstant } = require("../../helpers");

const service = "market";

module.exports = {
  CREATE_TRANSACTION: createConstant(service, "CREATE_TRANSACTION"),
  CREATE_TRANSACTION_SUCCESS: createConstant(
    service,
    "CREATE_TRANSACTION_SUCCESS"
  ),
  CREATE_TRANSACTION_ERROR: createConstant(service, "CREATE_TRANSACTION_ERROR"),
  CREATE_TRANSACTION_RESET: createConstant(service, "CREATE_TRANSACTION_RESET"),

  GET_INVOICE: createConstant(service, "GET_INVOICE"),
  GET_INVOICE_SUCCESS: createConstant(service, "GET_INVOICE_SUCCESS"),
  GET_INVOICE_ERROR: createConstant(service, "GET_INVOICE_ERROR"),
  GET_INVOICE_RESET: createConstant(service, "GET_INVOICE_RESET"),

  GET_TRANSACTIONS: createConstant(service, "GET_TRANSACTIONS"),
  GET_TRANSACTIONS_SUCCESS: createConstant(service, "GET_TRANSACTIONS_SUCCESS"),
  GET_TRANSACTIONS_ERROR: createConstant(service, "GET_TRANSACTIONS_ERROR"),
  GET_TRANSACTIONS_RESET: createConstant(service, "GET_TRANSACTIONS_RESET"),

  GET_TRANSACTION: createConstant(service, "GET_TRANSACTION"),
  GET_TRANSACTION_SUCCESS: createConstant(service, "GET_TRANSACTION_SUCCESS"),
  GET_TRANSACTION_ERROR: createConstant(service, "GET_TRANSACTION_ERROR"),
  GET_TRANSACTION_RESET: createConstant(service, "GET_TRANSACTION_RESET"),

  UPDATE_ADDRESS: createConstant(service, "UPDATE_ADDRESS"),
  UPDATE_ADDRESS_SUCCESS: createConstant(service, "UPDATE_ADDRESS_SUCCESS"),
  UPDATE_ADDRESS_ERROR: createConstant(service, "UPDATE_ADDRESS_ERROR"),
  UPDATE_ADDRESS_RESET: createConstant(service, "UPDATE_ADDRESS_RESET"),

  CART_CHECKOUT: createConstant(service, "CART_CHECKOUT"),
  CART_CHECKOUT_SUCCESS: createConstant(service, "CART_CHECKOUT_SUCCESS"),
  CART_CHECKOUT_ERROR: createConstant(service, "CART_CHECKOUT_ERROR"),
  CART_CHECKOUT_RESET: createConstant(service, "CART_CHECKOUT_RESET"),

  TRANSACTION_DELIVERY: createConstant(service, "TRANSACTION_DELIVERY"),
  TRANSACTION_DELIVERY_SUCCESS: createConstant(
    service,
    "TRANSACTION_DELIVERY_SUCCESS"
  ),
  TRANSACTION_DELIVERY_ERROR: createConstant(
    service,
    "TRANSACTION_DELIVERY_ERROR"
  ),
  TRANSACTION_DELIVERY_RESET: createConstant(
    service,
    "TRANSACTION_DELIVERY_RESET"
  ),

  DELIVERY_PRICELIST: createConstant(service, "DELIVERY_PRICELIST"),
  DELIVERY_PRICELIST_SUCCESS: createConstant(
    service,
    "DELIVERY_PRICELIST_SUCCESS"
  ),
  DELIVERY_PRICELIST_ERROR: createConstant(service, "DELIVERY_PRICELIST_ERROR"),
  DELIVERY_PRICELIST_RESET: createConstant(service, "DELIVERY_PRICELIST_RESET"),

  DELIVERY_LIST_PROVIDERS: createConstant(service, "DELIVERY_LIST_PROVIDERS"),
  DELIVERY_LIST_PROVIDERS_SUCCESS: createConstant(
    service,
    "DELIVERY_LIST_PROVIDERS_SUCCESS"
  ),
  DELIVERY_LIST_PROVIDERS_ERROR: createConstant(
    service,
    "DELIVERY_LIST_PROVIDERS_ERROR"
  ),
  DELIVERY_LIST_PROVIDERS_RESET: createConstant(
    service,
    "DELIVERY_LIST_PROVIDERS_RESET"
  ),
};
